import { useCallback, useState } from 'react'
import { gql, useMutation } from '@apollo/client'

export default (onSuccess, onError) => {
  const [mutation, { data, error, loading }] = useMutation(
    gql`mutation (
        $countryId: ID!
        $globalRate: Float
        $userId: ID!
        $customRate: Float            
    )
    {
        setToCustomGlobalRateEducator(
            input: {
                countryId: $countryId
                globalRate: $globalRate
                userId: $userId
                customRate: $customRate
            }
        )
    }`
  )
  const [validationErrors, setValidationErrors] = useState({})
  const submit = useCallback((obj) => {
    mutation({ variables: obj }).then((result) => {
      onSuccess(result)
    }).catch((e) => {
      setValidationErrors({ general: 'misc.apiError' })
      onError(e)
    })
  }, [mutation, onSuccess, onError])
  return { loading, data: data ? data.setToCustomGlobalRate : null, error, validationErrors, submit }
}
